module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/military-school-lvl2-50.78f0501f.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/military-school-lvl2-50.png
// module id = 3547
// module chunks = 11